<template>
  <form>
    <md-field>
      <label>Notes (optional)</label>
      <md-textarea v-model="notes" />
    </md-field>
    <div class="d-flex align-items-center">
      <md-button class="md-primary mt-3" :disabled="loading" @click="submit()">
        Submit
      </md-button>
      <md-progress-spinner
        class="mx-3"
        :md-diameter="30"
        :md-stroke="loading ? 4 : 0"
        md-mode="indeterminate"
      ></md-progress-spinner>
    </div>
  </form>
</template>

<script>
import ApiService from "@/services/api";

export default {
  name: "MarketTourForm",
  data() {
    return {
      notes: "",
      loading: false
    };
  },
  methods: {
    submit() {
      this.loading = true;

      ApiService.marketTours
        .submitTourInquiry(this.notes)
        .then(() => {
          this.notes = "";
          this.$toast.success("Market tour inquiry submitted successfully.");
        })
        .catch(error => {
          if (error.response.status === 422) {
            this.toastLaravelErrors(error);
          } else {
            this.$toast.error(error.response.data.message);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped></style>
